
export default {
  profileSelector: {
    activeProfile: 'Ativo'
  }
}
